import { RESET_STATE } from 'store/global/actions';

import { COMPANY_IP_WHITELIST_ACTION_TYPE } from '../actions';

const initialState = [];

const companyIpWhitelistReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_IP_WHITELIST_ACTION_TYPE.GET_ENTRIES:
      return payload || [];

    case COMPANY_IP_WHITELIST_ACTION_TYPE.ADD_ENTRY:
      return state.concat(payload);

    case COMPANY_IP_WHITELIST_ACTION_TYPE.UPDATE_ENTRY:
      return state.map(item => (item.id === payload.id ? payload : item));

    case COMPANY_IP_WHITELIST_ACTION_TYPE.REMOVE_ENTRY:
      return state.filter(item => item.id !== payload);

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default companyIpWhitelistReducer;
